.card {
  display: flex;
  position: relative;
  gap: 1.2rem;
  background: var(--color-grey-8);
  border-radius: 6px;
  padding: 1.6rem;
  min-height: 10rem;

  &[data-active='true'] {
    background: var(--color-grey-8-75);

    border: 0.1rem solid var(--color-secondary);
  }
}

.candidate-image-container {
  width: 6.4rem;
  height: 6.4rem;
  position: relative;
  cursor: pointer;

  & > div {
    padding: 0;
  }
}

.info-container {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  flex: 1;
  cursor: pointer;
}

.select-button-container {
  & button {
    background-color: var(--color-grey-7);
    border-radius: 0.6rem;

    & > svg {
      fill: none;
      stroke: var(--color-grey-5);
    }

    &:hover,
    &:active {
      background-color: var(--color-secondary);

      & > svg {
        fill: none;
        stroke: var(--white-default);
      }
    }
  }

  &[data-active='true'] {
    & button {
      background-color: var(--color-secondary);

      & > svg {
        stroke: var(--white-default);
      }
    }
  }
}

.remove-button-container {
  & button {
    background-color: var(--color-grey-7);
    border-radius: 0.6rem;

    & svg {
      fill: var(--color-grey-5);
      stroke: unset;
    }

    &:hover {
      background-color: #db5c66;

      & svg {
        stroke: unset;
        fill: var(--white-default);
      }
    }
  }
}

.right-container {
  height: calc(100% - 3.2rem);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.buttons-container {
  position: absolute;
  bottom: 1.6rem;
  right: 1.6rem;

  & > svg {
    top: 0;
    right: 0;
  }

  display: flex;
  gap: var(--spacing-gap-sm);
  align-items: end;
}

.candidate-name {
  font-size: 1.6rem;
  font-weight: 600;
  color: var(--white-default);
  line-height: 1.9rem;
}

.candidate-title {
  line-height: 1.7rem;
  color: var(--step-title-color);
  opacity: 0.6;
}
